import { render, staticRenderFns } from "./CompletaRegistrazione.vue?vue&type=template&id=6b7f9e12&scoped=true&"
import script from "./CompletaRegistrazione.vue?vue&type=script&lang=js&"
export * from "./CompletaRegistrazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f9e12",
  null
  
)

export default component.exports